import { useCallback, useEffect, useReducer } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import apiClient from '../_utils/axios';
import { getStringByLang } from '../libs/lang';
import slangKo from '../json/slang_ko';
import slangEn from '../json/slang_en';
import { debounce } from 'lodash';

const initalState = {
  data: { searchkey: '', keywordList: [], placeholder: getStringByLang('검색', 'Search', 'けんさく') },
};

const searchReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case 'RESET':
      return initalState;
    default:
      return state;
  }
};

class SearchService {
  async getKeyword(searchkey) {
    try {
      const res = await apiClient.get(`/web/keyword?page=1&size=5&searchText=${searchkey}`);
      if (res) {
        const newKeywords = res.data.data.map((v) => ({ label: v.keyword_name, value: v.keyword_name }));
        return {
          keywordList: newKeywords,
        };
      }
    } catch (error) {
      console.error('Error fetching keywords:', error);
      return {
        keywordList: [],
      };
    }
  }

  async postKeyword(keyword) {
    try {
      const res = await apiClient.post('/web/keyword', {
        keyword_name: keyword,
      });
      return res;
    } catch (error) {
      console.error('Error posting keyword:', error);
    }
  }
}

export const useSearch = () => {
  const [state, dispatch] = useReducer(searchReducer, initalState);
  const history = useHistory();
  const utils = new SearchService();

  useEffect(() => {
    const fetchKeywords = async () => {
      if (state.data.searchkey.length > 0) {
        const result = await utils.getKeyword(state.data.searchkey);
        if (result) {
          dispatch({ type: 'SET_DATA', payload: result });
        }
      } else {
        dispatch({ type: 'SET_DATA', payload: { keywordList: [] } });
      }
    };
    const debounceFetch = debounce(fetchKeywords, 300);
    debounceFetch(state.data.searchkey);

    return () => {
      debounceFetch.cancel();
    };
  }, [state.data.searchkey]);

  const actions = {
    setData: useCallback((payload) => {
      dispatch({ type: 'SET_DATA', payload });
    }, []),
    goSearch: useCallback(
      async (keyword) => {
        if (!slangKo.includes(keyword) && !slangEn.includes(keyword)) {
          const res = await utils.postKeyword(keyword);
          if (res) {
            history.push(`/design/all/all?keyword=${keyword}`);
          }
        } else {
          history.push(`/design/all/all?keyword=${keyword}`);
        }
      },
      [history],
    ),
  };

  return {
    state,
    actions,
  };
};
